import { render } from "./map-gps.vue?vue&type=template&id=28f31d62"
import script from "./map-gps.vue?vue&type=script&lang=js"
export * from "./map-gps.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/Web apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__